<template>
  <div class="w-full overflow-y-auto">
    <div class="w-full max-w-[1160px] min-w-[463px] pt-[36px] px-[32px] flex flex-col mx-auto mb-[50px]">
      <!-- Header -->
      <div class="flex flex-col mb-[16px]">
        <div class="flex items-center gap-[8px] mb-[4px]">
          <IconArrowLeft class="cursor-pointer" @click="backBtnActive = true" />
          <span class="text-[#212529] text-[20px] font-[500] leading-[120%]">Добавление клинически-значимого события</span>
        </div>

        <div class="text-[#6C757D] text-[16px] font-[400] leading-[150%]">Клинически-значимые события</div>
      </div>
        <!-- End Header -->
    <!-- Content -->
    <VSkeleton v-if="isLoading" class="w-full h-[456px] rounded-[8px]"/>
    <div v-else-if="isError" class="flex-1 min-h-0 flex">
        <v-placeholder
          message="Что-то пошло не так"
          description="Попробуйте повторить запрос <br> или обратитесь в службу поддержки"
          :icon="{ name: 'xl/mood-confuzed' }"
          :retry="{ label: 'Повторить запрос', handler: fetchNosologyList }"
          class="!min-h-[70vh] h-full w-full !p-[24px]"
        >
          <template #footer>
            <p class="text-14-reg-400">Позвонить в техподдержку</p>
            <a
              class="text-v-ui-text-main text-14-reg-400 mt-[8px]"
              href="tel:88005000299"
              >8 800 500-02-99</a
            >
          </template>
        </v-placeholder>
      </div>

      <div v-else>
        <div class="mx-[16px] my-[20px] text-16-reg-400 text-heading-primary">
          Шаг {{ curentStep }} из {{ totalSteps }}.<span class="title-16-medium-500"> {{ stepTitles[curentStep - 1] }} </span>
        </div>

        <component :is="currentStepComponent" v-bind="currentStepConfig.props" v-on="currentStepConfig.listeners" />
      </div>



      <!-- Back dialog -->
        <VDialog
        v-model="backBtnActive"
        title="Добавление клинически-значимого события"
        subtitle="Вы хотите прервать Добавление клинически-значимого события? Введённые данные не сохранятся."
        :leftButton="{ label: 'Прервать', handler: () => confirmBackHandler() }"
        :rightButton="{ label: 'Не прерывать', handler: () => backBtnActive = false }"
        />
      <!-- End back dialog -->
  </div>
  </div>
</template>

<script>
import {VSkeleton, VPlaceholder, VDialog, VButton} from '@gostelemed.front/rt-doctis.designsystem';
import IconArrowLeft from '@/assets/images/icon-left.svg';
import Step1 from '@/components/Kzs/KzsItems/CreateKzsFormSteps/Step1.vue';
import Step2 from '@/components/Kzs/KzsItems/CreateKzsFormSteps/Step2.vue';
import Step3 from '@/components/Kzs/KzsItems/CreateKzsFormSteps/Step3.vue';
import Step4 from '@/components/Kzs/KzsItems/CreateKzsFormSteps/Step4.vue';
import nosologyService from '@/services/nosology/nosology.service';
import kzsTemplateService from '@/services/kzs/kzs-templates/kzs-template.service';
import kzsService from '@/services/kzs/kzs.service';
import { TOASTS } from '@/services/core/ui/toasts.const';

export default {
  name: 'KzsAdd',
  page: {
    title: 'CRM Doctis - Клинически-значимые события',
  },
  components: {
    VSkeleton,
    VPlaceholder,
    IconArrowLeft,
    VDialog,
    VButton,
    Step1,
    Step2,
    Step3,
    Step4,
  },
  data() {
    return {
      nosologyList: [],
      assignmentTemplateList: [],
      // TODO: Поставить true
      isLoading: true,
      isError: false,
      backBtnActive: false,
      curentStep: 1,
      totalSteps: 4,
      algorithmData: null,
      stepComponents: [
        Step1,
        Step2,
        Step3,
        Step4,
      ],
      stepTitles: [
        'Добавление общих сведений',
        'Выбор типа КЗС и алгоритма',
        'Настройка алгоритма',
        'Подтверждение',
      ],
      kzsFormData: null,
    }
  },
  async mounted() {
    try {
      await this.fetchNosologyList();
      await this.fetchAssignmentTemplateList();
    } catch (error) {
      this.isError = true;
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    currentStepComponent() {
      return this.stepComponents[this.curentStep - 1];
    },
    currentStepConfig() {
      const stepConfigs = [
        {
          props: {
            nosologyList: this.nosologyList,
            assignmentTemplateList: this.assignmentTemplateList,
            fullKzsFormData: this.kzsFormData,
          },
          listeners: {
            'on-prev-step': this.prevStepHandler,
            'on-next-step': this.nextStepHandler,
            'on-fetch-data-success': () => { this.isLoading = false; this.isError = false; },
            'on-save-data': this.saveDataHandler,
          },
        },
        {
          props: {
            fullKzsFormData: this.kzsFormData,
          },
          listeners: {
            'on-prev-step': this.prevStepHandler,
            'on-next-step': this.nextStepHandler,
            'on-save-data': this.saveDataHandler,
            'on-save-algorithm-data': this.saveAlgorithmDataHandler,
          },
        },
        {
          props: {
            fullKzsFormData: this.kzsFormData,
            algorithmData: this.algorithmData,
          },
          listeners: {
            'on-prev-step': this.prevStepHandler,
            'on-next-step': this.nextStepHandler,
            'on-save-data': this.saveDataHandler,
            'on-update-alghoritm-params': this.updateAlghoritmParamsHandler,
          },
        },
        {
          props: {
            fullKzsFormData: this.kzsFormData,
            nosologyList: this.nosologyList,
            assignmentTemplateList: this.assignmentTemplateList,
            algorithmData: this.algorithmData,
          },
          listeners: {
            'on-prev-step': this.prevStepHandler,
            'on-next-step': this.nextStepHandler,
            'on-confirm-create-kzs': this.confirmCreateKzsHandler,
          },
        },
      ];

      return stepConfigs[this.curentStep - 1] || { props: {}, listeners: {} };
    },
  },
  methods: {

    // Обработка подтверждения прерывания создания КЗС
    confirmBackHandler() {
      this.$router.push('/remote-monitoring/kzs');
    },

    // Переход на предыдущий шаг
    prevStepHandler() {
      if (this.curentStep > 1) {
        this.curentStep = this.curentStep - 1;
      } else {
        this.backBtnActive = true;
      }
    },

    // Переход на следующий шаг
    nextStepHandler() {
      if (this.curentStep < this.totalSteps) {
        this.curentStep = this.curentStep + 1;
      }
    },

    // Запрос списка нозологий
    async fetchNosologyList() {
      try {
        this.nosologyList = await nosologyService.getShortNosologyList();
      } catch (error) {
        console.error(error);
      }
    },
    // Запрос списка шаблонов КЗС
    async fetchAssignmentTemplateList() {
      try {
        this.assignmentTemplateList = await kzsTemplateService.getShortKzsTemplateList();
      } catch (error) {
        console.error(error);
      }
    },
    // Сохранение данных КЗС заполненных на 1 и 2 шаге
    saveDataHandler(data) {
      this.kzsFormData = {
        ...this.kzsFormData,
        ...data,
      };
    },

    // Сохранение данных алгоритма для рендера формы на 3 шаге
    saveAlgorithmDataHandler(data) {
      this.algorithmData = data;
    },

    // Обработка обновления параметров алгоритма на 3 шаге
    updateAlghoritmParamsHandler(data) {
      this.kzsFormData.algorithm = {
        ...this.kzsFormData.algorithm,
        ...data,
      };
    },

    prepareKzsDataForCreate() {
      return {
        ...this.kzsFormData,
        type: this.kzsFormData.type?.id,
      };
    },

    // Обработка подтверждения создания КЗС
    async confirmCreateKzsHandler() {
      try {
        //TODO: Добавить запрос на создание КЗС
        const requestData = this.prepareKzsDataForCreate();
        const data = await kzsService.createKzs(requestData);
        this.$uiService.showToast(TOASTS.KZS_TASK_CREATE_SUCCESS);
        this.$router.push(`/remote-monitoring/kzs/view/${data.id}`);
      } catch (error) {
        console.error(error);
        this.$uiService.showToast(TOASTS.KZS_TASK_CREATE_ERROR);
      }
    },
  }
}
</script>
